import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
import ViewComponent from "../ViewComponent";
import telematicsService from "../../api/telematics.service";
import ImageInput from "@/views/ImageInput";

export default {
  name: "view-customer-owned-equipment-details",
  components: { pageheader, ViewComponent, ImageInput },

  data() {
    return {
      input: {},
      isCustomerEquipmentDetailsLoading: false,
      avatar: {
        imageURL: null,
      },
      saved: false,
      isUpload: false,
      isAvatar: false,
      componentName: "view-customer-owned-equipment-details",
      viewDataById: {},
      isDeleteImageURL: false,
    };
  },
  watch: {
    avatar: {
      handler: function (val) {
        if (val.isUpload) {
          this.isAvatar = true;
        }
        this.saved = false;
        val.isUpload = false;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    this.input = utils.getInputContent(
      "viewcustomerownedequpmentdetails",
      this.roles
    );
    this.readCustomerOwnedEqupmentDetailsById();
  },
  methods: {
    async readCustomerOwnedEqupmentDetailsById() {
      this.viewDataById = {};
      this.avatar = {
        imageURL: null,
      };
      this.isCustomerEquipmentDetailsLoading = true;
      try {
        let response =
          await telematicsService.getCustomerOwnedEqupmentDetailsByIdNew(
            this.$route.params.assetId
          );
        if (response.isSuccess) {
          this.isCustomerEquipmentDetailsLoading = false;
          this.viewDataById = response.data;
          this.checkIfImageExists(this.viewDataById.imageUrl, (exists) => {
            if (exists) {
              this.avatar.imageURL = this.viewDataById.imageUrl;
            } else {
              console.error("Image does not exists.");
            }
          });
        } else {
          this.isCustomerEquipmentDetailsLoading = false;
          this.viewDataById = {};
        }
      } catch (error) {
        this.isCustomerEquipmentDetailsLoading = false;
        this.$toast.error("Unable to load the data" + error);
      }
    },
    checkIfImageExists(url, callback) {
      const img = new Image();
      img.src = url;

      if (img.complete) {
        callback(true);
      } else {
        img.onload = () => {
          callback(true);
        };

        img.onerror = () => {
          callback(false);
        };
      }
    },
    async imgaeUpdateReload() {
      this.isUpload = false;
      this.viewDataById = {};
      try {
        let response =
          await telematicsService.getCustomerOwnedEqupmentDetailsByIdNew(
            this.$route.params.assetId
          );
        if (response.isSuccess) {
          this.viewDataById = response.data;
          this.checkIfImageExists(this.viewDataById.imageUrl, (exists) => {
            if (exists) {
              this.avatar.imageURL = this.viewDataById.imageUrl;
            } else {
              console.error("Image does not exists.");
            }
          });
        } else {
          this.viewDataById = {};
        }
      } catch (error) {
        this.$toast.error("Unable to load the data" + error);
      }
    },
    async uploadImage() {
      this.isUpload = true;
      try {
        let payload = {
          image64: this.avatar.imageString,
          imageType: this.avatar.imageType ? this.avatar.imageType : "",
          equipmentId: this.$route.params.assetId,
        };
        let response = await telematicsService.updateEquipmentImage(payload);
        if (response.isSuccess) {
          this.$toast.success("successfully updated");
          this.imgaeUpdateReload();
          this.isUpload = false;
        }
      } catch (err) {
        this.$toast.error("Unable to upload profile image" + err);
      }
      setTimeout(() => this.savedAvatar(), 1000);
    },
    savedAvatar() {
      this.isAvatar = false;
      this.saved = true;
    },
    cancelUpload() {
      if (this.viewDataById.imageUrl) {
        this.avatar.imageURL = this.viewDataById.imageUrl;
      }
      this.avatar.imageURL = null;
      setTimeout(() => this.savedAvatar(), 5);
    },
    updateRouterParams() {
      if (this.$route.query && this.$route.query.navigateFrom != "Map") {
        if (this.$route.query && this.$route.query.isFilter) {
          this.$router.push(
            `/customer-owned-equipment?serialNumber=${this.$route.query.serialNumber}&isFilter=${this.$route.query.isFilter}&toggleId=${this.$route.query.toggleId}`
          );
        } else {
          this.$router.push(
            `/customer-owned-equipment?isFilter=${this.$route.query.isFilter}&toggleId=${this.$route.query.toggleId}`
          );
        }
      } else {
        let ownerTypeQuery,
          assetTypeQuery,
          brandQuery,
          rentalQuery,
          modelQuery,
          groupQuery,
          alertsQuery,
          GPSReadingQuery,
          subTypeQuery,
          locationQuery,
          searchFieldQuery,
          searchContractFieldQuery,
          addressSearchQuery;
        if (this.$route.query && this.$route.query.isOwnerFilter) {
          ownerTypeQuery = {
            ownerTypeValue: this.$route.query.ownerTypeValue,
            ownerFinalValue: this.$route.query.ownerFinalValue,
            isOwnerFilter: this.$route.query.isOwnerFilter,
          };
        } else {
          ownerTypeQuery = {};
        }
        //Asset Query
        if (this.$route.query && this.$route.query.isAssetFilter) {
          assetTypeQuery = {
            assetValue: this.$route.query.assetValue,
            assetFinalValue: this.$route.query.assetFinalValue,
            isAssetFilter: this.$route.query.isAssetFilter,
          };
        } else {
          assetTypeQuery = {};
        }
        //Brand Query

        if (this.$route.query && this.$route.query.isBrandFilter) {
          brandQuery = {
            brandValue: this.$route.query.brandValue,
            isBrandFilter: this.$route.query.isBrandFilter,
          };
        } else {
          brandQuery = {};
        }
        //Rental Status Query
        if (this.$route.query && this.$route.query.isRentalStatusFilter) {
          rentalQuery = {
            rentalValue: this.$route.query.rentalValue,
            isRentalStatusFilter: this.$route.query.isRentalStatusFilter,
          };
        } else {
          rentalQuery = {};
        }
        // Model Filter
        if (this.$route.query && this.$route.query.isModelFilter) {
          modelQuery = {
            modelValue: this.$route.query.modelValue,
            isModelFilter: this.$route.query.isModelFilter,
          };
        } else {
          modelQuery = {};
        }
        //Group Filter
        if (this.$route.query && this.$route.query.isGroupFilter) {
          groupQuery = {
            groupValue: this.$route.query.groupValue,
            isGroupFilter: this.$route.query.isGroupFilter,
          };
        } else {
          groupQuery = {};
        }
        //Sub Type Filter
        if (this.$route.query && this.$route.query.isSubTypeFilter) {
          subTypeQuery = {
            subTypeValue: this.$route.query.subTypeValue,
            lowVoltage: this.$route.query.lowVoltage,
            lowDef: this.$route.query.lowDef,
            lowFuel: this.$route.query.lowFuel,
            isSubTypeFilter: this.$route.query.isSubTypeFilter,
          };
        } else {
          subTypeQuery = {};
        }
        //Location Filter
        if (this.$route.query && this.$route.query.isLocationFilter) {
          locationQuery = {
            locationValue: this.$route.query.locationValue,
            isLocationFilter: this.$route.query.isLocationFilter,
          };
        } else {
          locationQuery = {};
        }
        //Search Field Query
        if (this.$route.query && this.$route.query.isContractSearchFilter) {
          searchFieldQuery = {
            searchFieldValue: this.$route.query.searchFieldValue,
            isContractSearchFilter: this.$route.query.isContractSearchFilter,
          };
        } else {
          searchFieldQuery = {};
        }
        //sear new field query
        if (this.$route.query && this.$route.query.contractIdFilter) {
          searchContractFieldQuery = {
            searchContractFieldValue:
              this.$route.query.searchContractFieldValue,
            contractIdFilter: this.$route.query.contractIdFilter,
          };
        } else {
          searchContractFieldQuery = {};
        }
        // Address Search Query
        if (this.$route.query && this.$route.query.isAddressFilter) {
          addressSearchQuery = {
            addressSearchValue: this.$route.query.addressSearchValue,
            isAddressFilter: this.$route.query.isAddressFilter,
          };
        } else {
          addressSearchQuery = {};
        }
        //Alerts Query
        if (this.$route.query && this.$route.query.isAlertsFilter) {
          alertsQuery = {
            alertValue: this.$route.query.alertValue,
            isAlertsFilter: this.$route.query.isAlertsFilter,
          };
        } else {
          alertsQuery = {};
        }
        //GPS Reading Query
        if (this.$route.query && this.$route.query.isLastGPSReadingFilter) {
          GPSReadingQuery = {
            gpsReadingValue: this.$route.query.gpsReadingValue,
            isLastGPSReadingFilter: this.$route.query.isLastGPSReadingFilter,
          };
        } else {
          GPSReadingQuery = {};
        }
        let finalRouteQuery = {
          ...ownerTypeQuery,
          ...assetTypeQuery,
          ...brandQuery,
          ...rentalQuery,
          ...modelQuery,
          ...groupQuery,
          ...alertsQuery,
          ...GPSReadingQuery,
          ...subTypeQuery,
          ...locationQuery,
          ...searchFieldQuery,
          ...searchContractFieldQuery,
          ...addressSearchQuery,
        };
        this.$router
          .push({ path: "/", query: finalRouteQuery })
          .catch(() => {});
      }
    },
    async deleteImageURL() {
      this.isDeleteImageURL = true;
      try {
        let response = await telematicsService.deleteCustomerEquipmentImage(
          this.$route.params.assetId
        );
        if (response.isSuccess) {
          this.isDeleteImageURL = false;
          this.$toast.success("Successfully deleted");
          this.imgaeUpdateReload();
          this.avatar = {
            imageURL: null,
          };
        } else {
          this.isDeleteImageURL = false;
          this.$toast.error(response.systemMessage);
        }
      } catch (err) {
        console.log(err);
        this.isDeleteImageURL = false;
        this.$toast.error("Unable to delete the image");
      }
    },
  },
};
